var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.277L22.28 24l-6.037-6.044c-1.808 1.402-3.995 2.16-6.211 2.16C4.52 20.117 0 15.62 0 10.074 0 4.526 4.52.029 10.06 0c5.541 0 10.062 4.496 10.062 10.044a9.944 9.944 0 01-2.158 6.219zm-13.968-4.554c4.199 0 7.61-3.416 7.61-7.62 0-4.205-3.411-7.621-7.61-7.621-4.2 0-7.612 3.416-7.612 7.62 0 4.205 3.412 7.62 7.612 7.62z"
  })));
}
export default __webpack_public_path__ + "static/svg/search-icon.svg";
export { SvgSearchIcon as ReactComponent };